import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Global tenant override for super_admin (set by AppContext)
export const tenantStore = { id: null, isSuper: false };

export function setTenantContext(id, isSuper) {
  tenantStore.id = id;
  tenantStore.isSuper = isSuper;
}

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("pm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (tenantStore.isSuper && tenantStore.id) {
    config.params = { tenant_id: tenantStore.id, ...(config.params || {}) };
  }
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("login")) {
      localStorage.removeItem("pm_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export async function downloadFile(path, filename) {
  const params = tenantStore.isSuper && tenantStore.id ? { tenant_id: tenantStore.id } : {};
  const res = await client.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default client;
